<div fxLayout="column" fxLayoutAlign="center center" fxFlexFill class="sam-margin">
   <fa-icon [icon]="icon" size="3x" spin="true"></fa-icon>
</div>
